import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import SentimentAnalysis from "./SentimentAnalysis";
import EmotionalEmpathy from "./EmotionalEmpathy";
import LongitudinalSentiment from "./longitudinal_sentiment";

const EmotionalConnect = ({
  username,
  appointmentId,
  appointment,
  callEndTime,
  postCallWindowExpired = false,
  finalFetchStatuses = {},
  onDocumentSelect,
}) => {
  // Keep inner-tab selection local, just like the working DEV version.
  const [selectTab, setSelectTab] = useState("emotionalEmpathy");

  const tabs = [
    { id: "emotionalEmpathy", label: "Emotional Empathy" },
    { id: "sentimentAnalysis", label: "Sentiment Analysis" },
    { id: "longitudinalSentiment", label: "Longitudinal Sentiment" },
  ];

  return (
    <Card className="mt-8">
      <CardHeader>
        <CardTitle>Emotional Connect</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex space-x-2 mb-6 justify-left">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`px-4 py-2 rounded font-medium ${selectTab === tab.id
                ? "bg-blue-600 text-white"
                : "bg-white text-neutral-800 border border-b-0"
                } transition`}
              onClick={() => {
                setSelectTab(tab.id);
                onDocumentSelect?.(tab.id);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {selectTab === "emotionalEmpathy" && (
          <EmotionalEmpathy
            username={username}
            appointmentId={appointmentId}
            appointment={appointment}
            callEndTime={callEndTime}
            postCallWindowExpired={postCallWindowExpired}
            finalFetchStatus={finalFetchStatuses.emotionalEmpathy}
          />
        )}

        {selectTab === "sentimentAnalysis" && (
          <SentimentAnalysis
            username={username}
            appointmentId={appointmentId}
            callEndTime={callEndTime}
            postCallWindowExpired={postCallWindowExpired}
            finalFetchStatus={finalFetchStatuses.sentimentAnalysis}
          />
        )}

        {selectTab === "longitudinalSentiment" && (
          <LongitudinalSentiment
            username={username}
            appointmentId={appointmentId}
            callEndTime={callEndTime}
            postCallWindowExpired={postCallWindowExpired}
            finalFetchStatus={finalFetchStatuses.longitudinalSentiment}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default EmotionalConnect;
